const FONT_CONFIGS = {
  ja: {
    families: ['Noto Sans JP:wght@300;400;500;600;700;800'],
    display: 'swap',
  },
  en: {
    families: ['Open Sans:wght@300;400;500;600;700'],
    display: 'swap',
  },
  'zh-CN': {
    families: ['Noto Sans SC:wght@300;400;500;600;700'],
    display: 'swap',
  },
  'zh-TW': {
    families: ['Noto Sans TC:wght@300;400;500;600;700'],
    display: 'swap',
  },
  'zh-HK': {
    families: ['Noto Sans TC:wght@300;400;500;600;700'],
    display: 'swap',
  },
  ko: {
    families: ['Noto Sans KR:wght@300;400;500;600;700'],
    display: 'swap',
  },
  th: {
    families: ['Noto Sans Thai:wght@300;400;500;600;700'],
    display: 'swap',
  },
  vi: {
    families: ['Noto Sans Vietnamese:wght@300;400;500;600;700'],
    display: 'swap',
  },
  id: {
    families: ['Noto Sans:wght@300;400;500;600;700'],
    display: 'swap',
  },
  de: {
    families: ['Open Sans:wght@300;400;500;600;700'],
    display: 'swap',
  },
  es: {
    families: ['Open Sans:wght@300;400;500;600;700'],
    display: 'swap',
  },
  fr: {
    families: ['Open Sans:wght@300;400;500;600;700'],
    display: 'swap',
  },
  it: {
    families: ['Open Sans:wght@300;400;500;600;700'],
    display: 'swap',
  },
};

class DynamicFontLoader {
  constructor() {
    this.loadedFonts = new Set();
    this.loadingPromises = new Map();
  }

  async loadFont(locale) {
    if (this.loadedFonts.has(locale)) {
      return Promise.resolve();
    }

    if (this.loadingPromises.has(locale)) {
      return this.loadingPromises.get(locale);
    }

    const config = FONT_CONFIGS[locale];
    if (!config) {
      return Promise.resolve();
    }

    const loadPromise = this.loadGoogleFont(config.families, config.display);
    this.loadingPromises.set(locale, loadPromise);

    try {
      await loadPromise;
      this.loadedFonts.add(locale);
    } catch (error) {
      console.warn(`Failed to load font for locale ${locale}:`, error);
      this.loadingPromises.delete(locale);
    }

    return loadPromise;
  }

  validateFontFamily(family) {
    // フォントファミリー名の検証（セキュリティ強化）
    if (!family.match(/^[a-zA-Z0-9\s:;@&=+,.-]+$/)) {
      throw new Error(`Invalid font family name: ${family}`);
    }
    return true;
  }

  loadGoogleFont(families, display = 'swap') {
    return new Promise((resolve, reject) => {
      try {
        // 入力値検証
        families.forEach(family => this.validateFontFamily(family));

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = `https://fonts.googleapis.com/css2?${families.map(family => `family=${encodeURIComponent(family)}`).join('&')}&display=${display}`;

        link.onload = resolve;
        link.onerror = reject;

        document.head.appendChild(link);
      } catch (error) {
        reject(error);
      }
    });
  }

  preloadBasicFonts() {
    // 日本語と英語は事前読み込み
    return Promise.all([this.loadFont('ja'), this.loadFont('en')]);
  }
}

export const fontLoader = new DynamicFontLoader();
